<template>
  <app-loading
    v-if="!$auth.$state.profile || loadingProfile"
    logo="/img/logo.jpg"
    :background="$vuetify.theme.themes.light.info"
    logo-background="#00447c"
  />
  <v-app
    v-else
    v-scroll="onScroll"
    class="layout-default"
    dark
  >
    <v-app-bar
      class="elevation-0"
      :class="offsetTop && 'v-app-bar--fill'"
      :dark="!offsetTop"
      app
    >
      <v-container class="d-flex align-center">
        <v-btn
          class="no-active"
          icon
          @click="resetAnswers"
        >
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <span
          v-if="$route.path !== '/'"
          class="font-weight-bold ml-3"
        >
          Hi,
          {{ contact.firstName }}
          {{ contact.lastName }}
        </span>
        <v-spacer />
        <span class="font-weight-bold ml-3">
          {{ $auth.$state.profile.name }}
        </span>
        <v-btn
          icon
          @click="$auth.logout"
        >
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
      </v-container>
    </v-app-bar>
    <v-main>
      <v-container class="my-md-8">
        <v-card>
          <v-card-text>
            <screener-stepper :page="pageName" />

            <transition
              name="fade"
              mode="out-in"
            >
              <router-view />
            </transition>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import { contact, resetAnswers } from '@/use/screener'
import { useProfile } from '@/use/profile'

export default {
  setup: (_, { root }) => {
    const { loadingProfile, getProfile } = useProfile()

    const offsetTop = ref(0)
    const onScroll = () => {
      offsetTop.value = pageYOffset
    }
    const pageName = computed(() =>
      root.$route.path.replace('/', '') || 'intro')

    onMounted(() => {
      getProfile()
      resetAnswers()
    })

    return {
      offsetTop,
      onScroll,
      pageName,

      contact,
      resetAnswers,
      loadingProfile
    }
  }
}
</script>

<style lang="scss">
.layout-default {
  .v-application {
    &--wrap {
      background-color: aliceblue;

      > main.v-main {
        z-index: 1;
      }

      &:before {
        z-index: 0;
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 350px;

        background-image: url('/img/sleep_couple.jpg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }

      &:after {
        z-index: 0;
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 350px;

        background-image: linear-gradient(to right, #0054D080, #01A09080);
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }

      .v-app-bar {
        background-color: transparent !important;
        border-bottom: 1px solid #fff4;
        transition: all .5s;

        &--fill {
          background-color: #FFFE !important;
          border-bottom-color: #3334;
        }
      }
    }
  }
}
</style>
